<div class="container">
  <h2>Redirecting you to a benefit review survey.</h2>
  <p>Thank you, once survey is completed, you can return to this site.</p>
</div>
